// extracted by mini-css-extract-plugin
export default {"dialog__content":"UpnEsoLookup_dialog__content__i1Ulf","person-search":"UpnEsoLookup_person-search__k5HHp"};